import {
  View,
  Image,
  Text,
  Alert,
  Switch,
  TextInput,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Modal,
} from "react-native";
import React, { useState } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import CheckBox from "expo-checkbox";
import { setJobtitleHook } from "../../../../../redux/profile/profileSlice";
import { dispatch } from "../../../../../redux/store";
import editProfileStyle from "../../../styles/editProfileStyle";
import settingsStyle from "../../../styles/settingsStyle";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import CustomComponent from "../../../../../components/CustomComponent";
import styles from "../../../styles/styles";

export default function EditJobTitle({
  navigation,
  route,
}: {
  navigation: any;
  route: any;
}) {
  const { staticData, setStaticData } = route.params;

  const [isEnabled, setIsEnabled] = useState(false);
  const toggleSwitch = () => setIsEnabled((previousState) => !previousState);
  function handleTextChange(text: string) {
    // console.log(text);
    // dispatch(setJobtitleHook(text));
    setStaticData((prev: any) => {
      return { ...prev, userInfo: { ...prev.userInfo, currentPosition: text } };
    });
  }
  const [toggleCheckBox, setToggleCheckBox] = useState(false);

  return (
    <SafeAreaView
      style={{
        backgroundColor: "white",
        width: "100%",
        display: "flex", height: "100%",
        alignItems: "center",
      }}
    >
      <View style={editProfileStyle.stickTopBar}>
        <View style={editProfileStyle.backBoxMain}>
          <View style={[settingsStyle.backBox, {  }]}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              {/* <Image source={FeedIcons.BackIcon} /> */}
              <FeedIcons.BackIcon />
            </TouchableOpacity>
            <Text style={GlobalStyles.heading3}>Job title</Text>
          </View>
        </View>
      </View>
      <View style={{ backgroundColor: "white", width: "90%", height: "90%" }}>
        <View style={{ marginTop: 30, width: '100%', height: 60 }}>
          <CustomComponent.InputField
            placeholder={"Job title"}
            onTextChange={handleTextChange}
          />
          {/* <Text style={[GlobalStyles.bodyText, { marginTop: 10 }]}>Always visible on profile</Text> */}
        </View>
        <View style={styles.innerBottom}>
          <CheckBox
            //   tintColors={{ true: "rgba(192, 164, 111, 1)" }}
            disabled={false}
            value={toggleCheckBox}
            onValueChange={(newValue) => setToggleCheckBox(newValue)}
            style={styles.checkBox}
            //   onCheckColor="rgba(192, 164, 111, 1)"
          />
          <Text style={GlobalStyles.bodyText}>Always visible on profile</Text>
        </View>

        <View style={{ height: 100 }}></View>
      </View>
    </SafeAreaView>
  );
}
